import React from 'react';
import css from './CategoryItem.module.css';
import ElementorButton from './ElementorButton';

interface CategoryItemProps {
    label: string;
    isSelected: boolean;
    onClick: () => void;
}

const CategoryItem: React.FC<CategoryItemProps> = (props) => {
    const { label, onClick, isSelected } = props;

    return (
        <ElementorButton className={isSelected ? css.Selected : ''} onClick={onClick}>
            {label}
        </ElementorButton>
    );
};

export default CategoryItem;
